import { render, staticRenderFns } from "./CardCompanyWall.vue?vue&type=template&id=b2ed9e56&scoped=true&"
import script from "./CardCompanyWall.vue?vue&type=script&lang=js&"
export * from "./CardCompanyWall.vue?vue&type=script&lang=js&"
import style0 from "./CardCompanyWall.vue?vue&type=style&index=0&id=b2ed9e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ed9e56",
  null
  
)

export default component.exports